import React, { Component } from 'react';
import { connect } from 'react-redux';
import { IonButton, IonIcon } from '@ionic/react';
import { copyOutline } from 'ionicons/icons';
import { Clipboard } from '@capacitor/clipboard';

import Layout from '../../components/layout';
import Loading from '../../components/spinner';
import { NormalText, SmallText, Spacer, StrongText, Subtitle, Title } from '../../components/common';
import { withTranslation } from '../../lib/translate';

import './index.css';
import { forwardTo, getGiftCardNumber, getMaskedGiftCardNumber } from '../../lib/utils';
import { QRCodeCanvas } from 'qrcode.react';
import Barcode from 'react-barcode';
import { getConfig } from '../../appConfig';
import Basket from '../../lib/basket';
import moment from 'moment';
import { removeGiftCard, showToast } from '../../store/actions';

class GiftCard extends Component {
    // Some Square terminals only read barcodes: the client picks which code shows first,
    // and tapping the code switches between QR and a Code 128 barcode.
    state = { showBarcode: getConfig().flags.giftCardCodeType === 'barcode' }

    componentDidMount() {
        if (!this.props.location?.state?.card) {
            forwardTo('/loyalty')
        }
    }

    copyGiftCardNumber = async (number) => {
        try {
            await Clipboard.write({ string: number })
            this.props.dispatch(showToast(this.props.__('Copied to clipboard'), 'success', 'toast'))
        } catch (e) {
            this.props.dispatch(showToast(this.props.__('Could not copy'), 'warning', 'toast'))
        }
    }

    render() {
        const { __ } = this.props;
        const card = this.props.location?.state?.card
        const isExpired = this.props.location?.state?.isExpired
        const expiresToday = this.props.location?.state?.expiresToday
        const title = `${__(card?.is_topup_card ? 'Top Up card' : card?.is_event_card ? 'Event card' : 'Gift card')} ${getMaskedGiftCardNumber(card)}`
        const expiryMoment = moment(card?.expiry_date, 'DD/MM/YYYY')
        const expiryDate = expiryMoment.format('LLLL')
        const history = [...(card?.history || [])].sort((a, b) => moment(b.timestamp) - moment(a.timestamp))
        const isUsed = !(card?.value_remaining > 0)
        const cardNumber = getGiftCardNumber(card)
        return (
            <Loading transparent>
                <Layout headerWithTitle color="transparent" title={title}>
                    <div className='absolute-content scrollable-y flex-row-wrapper'>
                        <div>
                        <Title className='web-only page-title-centered'>{title}</Title>
                        <div className='gift-card-qr-wrapper'>
                            {cardNumber && (
                                <div className='gift-card-qr pointer' onClick={() => this.setState(prev => ({ showBarcode: !prev.showBarcode }))}>
                                    {this.state.showBarcode ? (
                                        <Barcode value={cardNumber} format='CODE128' width={1.6} height={70} margin={0} displayValue={false} />
                                    ) : (
                                        <QRCodeCanvas value={cardNumber} size={150} />
                                    )}
                                </div>
                            )}
                            <div className='gift-card-number-wrapper' onClick={() => this.copyGiftCardNumber(cardNumber)}>
                                <StrongText className='gift-card-number'>{cardNumber}</StrongText>
                                <IonIcon icon={copyOutline} />
                            </div>
                            <SmallText className='text-to-update'>{__('Scan at the counter to pay')}</SmallText>
                            {cardNumber && <SmallText className='text-to-update'>{__(this.state.showBarcode ? 'Tap the code to show a QR code' : 'Tap the code to show a barcode')}</SmallText>}
                        </div>
                        <Spacer size={2} />
                        <div className='box-content flex-wrapper flex-justify-between flex-align-center'>
                            <div>
                                <StrongText className='block text-to-update'>{__('Balance')}</StrongText>
                                {expiryMoment.isValid() && (
                                    <SmallText className={`block${isExpired || expiresToday ? ' danger-color' : ''}`}>
                                        {expiresToday ? __('Expires today') : `${__(isExpired ? 'Expired' : 'Expires')} ${expiryDate}`}
                                    </SmallText>
                                )}
                            </div>
                            <StrongText>{Basket.formatPrice(card?.value_remaining / 100, true)}</StrongText>
                        </div>
                        {history.length > 0 && (
                            <>
                                <Spacer size={5} />
                                <StrongText className='block text-to-update'>{__('Transactions')}</StrongText>
                                <Spacer size={2} />
                                <div className='box-wrapper box-wrapper-list'>
                                    {history.map((el, index) => {
                                        const isCredit = el.type == 'value_added' || el.type == 'value_refunded'
                                        return (
                                            <div key={`card_${index}`} className='flex-wrapper flex-justify-between flex-align-center'>
                                                <div>
                                                    <StrongText className='block text-to-update'>{el.type == 'value_added' ? __('Value added') : el.type == 'value_refunded' ? __('Value refunded') : __('Value spent')}</StrongText>
                                                    <SmallText className='block'>{moment(el.timestamp).format('LLLL h:mm a')}</SmallText>
                                                </div>
                                                <StrongText >
                                                    {`${isCredit ? '+' : '-'}${Basket.formatPrice(el.value / 100, true)}`}
                                                </StrongText>
                                            </div>
                                        )
                                    })}
                                </div>
                            </>
                        )}
                        </div>
                        {isUsed && (
                            <div className='flex-min'>
                                <Spacer size={5} />
                                <IonButton className='button-uppercase' color='primary' expand='block' onClick={() => this.props.dispatch(removeGiftCard(card.id))}>
                                    {__('Delete gift card')}
                                </IonButton>
                            </div>
                        )}
                    </div>
                </Layout>
            </Loading>
        );
    }
}

const stateToProps = (state) => {
    return {
    };
};

export default connect(stateToProps)(withTranslation(GiftCard));
